<template>
  <div class="popup__wrapper" :class="{'popup__wrapper--tablet-hidden': this.tablet === 'hidden'}">
    <img
        class="popup__icon"
        @mouseover="showPopup = true" @mouseleave="hideContent()"
        src="@/create/assets/icons/msg-question.svg" alt="?"
    >
    <div v-show="showPopup" class="popup__content"
         :class="{
			'popup__content--makc-social-card': this.type === 'makc_social_card',
			'popup__content--makc-text': this.type === 'makc_text'
		}"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tablet', 'type'],
  data() {
    return {
      showPopup: false,
    };
  },
  methods: {
    hideContent() {
      setTimeout(() => {
        this.showPopup = false
      }, 0);
    },
  },
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
